// @flow
import { handleResponseOld, makeGet, makePatch /*, makePost */ } from './helpers';
import { getImageUrl } from '../../utils/urls';

const transformConversations = ({ error, meta, payload }) => {
    const transformedPayload = Boolean(payload)
        ? payload.map((conv: Object) => {
              const { id, name, logoUrl } = conv.participants.find(p => p.type === 'house');
              let imageUrl =
                  getImageUrl({
                      catalogId: conv.catalogId,
                      imageNumber: 1,
                      itemId: conv.lotId,
                      sellerId: id,
                      width: 100,
                  }) || logoUrl;

              return {
                  catalogId: conv.catalogId,
                  conversationId: conv.conversationId,
                  folderId: conv.folderId,
                  imageUrl,
                  lotId: conv.lotId,
                  messageCount: conv.messageCount,
                  read: conv.read,
                  sender: name,
                  subject: conv.subject,
              };
          })
        : [];

    return {
        error,
        meta,
        payload: transformedPayload,
    };
};

const SAMPLE_DATA = (query: Object) => {
    return {
        data: {
            error: false,
            meta: {
                pagination: {
                    pageNumber: query.page,
                    pageSize: query.pageSize,
                    totalPages: 23,
                    totalResults: 1232,
                },
            },
            payload: [
                {
                    catalogId: 124519,
                    conversationId: 16054918,
                    folderId: null,
                    lotId: 63306188,
                    messageCount: 1,
                    participants: [
                        {
                            id: 1391153,
                            name: 'wes-christiansen',
                            type: 'bidder',
                        },
                        {
                            id: 869,
                            logoUrl: 'https://images.liveauctioneers.com/houses/logos/hm/test450_hm.jpg',
                            name: 'Acme Auction House',
                            type: 'house',
                        },
                    ],
                    read: true,
                    subject: 'General Question',
                    tsLastMessageSent: 1583274533,
                },
                {
                    catalogId: 124519,
                    conversationId: 16054919,
                    folderId: null,
                    lotId: 0,
                    messageCount: 12,
                    participants: [
                        {
                            id: 1391153,
                            name: 'wes-christiansen',
                            type: 'bidder',
                        },
                        {
                            id: 869,
                            logoUrl: 'https://images.liveauctioneers.com/houses/logos/hm/test450_hm.jpg',
                            name: 'Acme Auction House',
                            type: 'house',
                        },
                    ],
                    read: true,
                    subject: 'Lot 0010: EDWARD ALENIUS, ARPS - Central Park Lake',
                    tsLastMessageSent: 1583274533,
                },
                {
                    catalogId: 162584,
                    conversationId: 16054920,
                    folderId: null,
                    lotId: 82120746,
                    messageCount: 6,
                    participants: [
                        {
                            id: 1391153,
                            name: 'wes-christiansen',
                            type: 'bidder',
                        },
                        {
                            id: 197,
                            logoUrl:
                                'https://images.liveauctioneers.com/houses/logos/lg/lesliehindman_large.jpg?auto=webp&format=pjpg&width=140',
                            name: 'Hindman',
                            type: 'house',
                        },
                    ],
                    read: true,
                    subject: 'Lot 0010: Lyn Godley and Lloyd Schwan (American, b. 1956 |',
                    tsLastMessageSent: 1583234531,
                },
            ],
        },
    };
};

type FetchConversationParams = {
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
};

type FetchConversationsParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    query?: Object,
};

type ConversationActionsParams = {
    authToken: string,
    bidderId: number,
    conversations: number[],
    deployment: string,
    folderId?: number,
};

export default {
    fetchConversation: ({ authToken, bidderId, conversationId, deployment }: FetchConversationParams) =>
        new Promise<any>((resolve, reject) => {
            if (true) {
                console.log('Sending a request for fetching convo: ', conversationId);
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA({}).data));
            } else {
                const request = makeGet({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
                });
                request.query({ conversationId });
                request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
            }
        }),

    fetchConversations: ({ authToken, bidderId, deployment, query = {} }: FetchConversationsParams) =>
        new Promise<any>((resolve, reject) => {
            if (false) {
                console.log('Sending a request for getting conversations', query);
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA(query).data));
                // }, 2000);
            } else {
                const request = makeGet({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
                });
                request.query(query);
                request.end((err, response) =>
                    handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
                );
            }
        }),

    markConversationRead: ({ authToken, bidderId, deployment, conversations }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            if (false) {
                console.log('Sending a request for marking ', conversations, ' read');
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA({}).data));
                // }, 2000);
            } else {
                const request = makePatch({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations/`,
                });
                request.send(
                    conversations.map(id => ({
                        id,
                        op: 'replace',
                        path: `/read`,
                        value: true,
                    }))
                );
                request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
            }
        }),

    markConversationUnread: ({ authToken, bidderId, deployment, conversations }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            if (false) {
                console.log('Sending a request for marking ', conversations, ' unread');
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA({}).data));
                // }, 2000);
            } else {
                const request = makePatch({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations/`,
                });
                request.send(
                    conversations.map(id => ({
                        id,
                        op: 'replace',
                        path: `/read`,
                        value: false,
                    }))
                );
                request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
            }
        }),
    moveConversation: ({ authToken, bidderId, deployment, conversations, folderId = 0 }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            if (false) {
                console.log('Sending a request for moving ', conversations);
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA({}).data));
                // }, 2000);
            } else {
                const request = makePatch({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations/`,
                });
                request.send(
                    conversations.map(id => ({
                        id,
                        op: 'replace',
                        path: `/folder/id`,
                        value: folderId,
                    }))
                );
                request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
            }
        }),
    trashConversations: ({ authToken, bidderId, deployment, conversations }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            if (false) {
                console.log('Sending a request for deleting ', conversations);
                // setTimeout(() => {
                return resolve(transformConversations(SAMPLE_DATA({}).data));
                // }, 2000);
            } else {
                const request = makePatch({
                    authToken,
                    deployment,
                    path: `<MESSAGING-API>bidders/${bidderId}/conversations/`,
                });
                request.send(
                    conversations.map(id => ({
                        id,
                        op: 'replace',
                        path: `/folder/id`,
                        value: -1,
                    }))
                );
                request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
            }
        }),
};
